import { render } from "./MBooks.vue?vue&type=template&id=604a55ba&scoped=true"
import script from "./MBooks.vue?vue&type=script&lang=js"
export * from "./MBooks.vue?vue&type=script&lang=js"

import "./MBooks.vue?vue&type=style&index=0&id=604a55ba&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604a55ba"]])

export default __exports__